import { history as _history } from 'prosemirror-history';

import historyKeymap from './plugins/keymap';

const history = {

	plugins() {

		return [_history(), historyKeymap];

	},

};

export default history;
